import { supportsCssVars } from "./browser";

export const getCssVar = (property, element) => {
  if (!supportsCssVars) {
    return;
  }
  if (!element) {
    element = document.querySelector(":root");
  }
  return getComputedStyle(element).getPropertyValue(property);
};

export const setCssVar = (property, value, element) => {
  if (!supportsCssVars) {
    return;
  }
  if (!element) {
    element = document.querySelector(":root");
  }
  element.style.setProperty(property, value);
};



// WEBPACK FOOTER //
// /Users/dcsturm/wrk/packages/composer/zd-wp-sage-lib/resources/assets/scripts/util/cssVars.js